const teqip3=[
    {
        'sno':'1',
        'particulars':'Procurement of Goods',
        'budget':'Rs.3,50,00,000/-'
    },
    {
        'sno':'2',
        'particulars':'Academic Activities',
        'budget':'Rs.2,80,00,000/-'
    },
    {
        'sno':'3',
        'particulars':'Operating Cost',
        'budget':'Rs.70,00,000/-'
    },
    {
        'particulars':'Total Amount (Rs.)',
        'budget':'Rs. 7,00,00,000/-'
    }
]

const t3_acad=[
    {
        'sno':'1',
        'fac_name':`Dr.T.K.Shanthi,\nProfessor/ECE`,
        'prog_name':'Training Workshop for Faculty Mentor on Induction programme',
        'place':'IIT, Guwahati',
        'from':'13.10.2017',
        'to':'15.10.2017'
    },
    {
        'sno':'2',
        'fac_name':`Dr.S.Nageswari,\nAssistant Professor/EEE`,
        'prog_name':'NBA Orientation Workshop',
        'place':'JW Marriortt Hotel, Pune',
        'from':'30.10.2017',
        'to':'31.10.2017'
    },
    {
        'sno':'3',
        'fac_name':'Prof.L.Rasikannan,\nAssistant Professor/CSE',
        'prog_name':'One Day Orientation Workshop SLA',
        'place':'AICTE, Auditorium, New Delhi',
        'from':'11.11.2017',
        'to':'-'
    },
    {
        'sno':'4',
        'fac_name':'Prof.R.Prakash,\nAssistant Professor/Civil',
        'prog_name':'Application of ANSYS In Structural Engineering',
        'place':'MEPCO Schlenk Engineering College, Sivakasi',
        'from':'17.11.2017',
        'to':'19.11.2017'
    },
    {
        'sno':'5',
        'fac_name':'Dr.R.Vasanthi,\nAssistant Professor/Maths',
        'prog_name':'“Training Workshop for Faculty Mentor on Induction Programme',
        'place':'IIT, Thirupathi',
        'from':'03.12.2017',
        'to':'06.12.2017'
    },
    {
        'sno':'6',
        'fac_name':'Dr.S.R.Sumathi,\nAssistant Professor/Civil',
        'prog_name':'“Risk Based Damage Tolerant Seismic of Structures : A New Paradigm”',
        'place':'IIT, Guwahati',
        'from':'18.12.2017',
        'to':'27.12.2017'
    },
    {
        'sno':'7',
        'fac_name':'Prof.G.Panneerselvam,\nAssociate Professor/Civil',
        'prog_name':'Ground Penetrating Rader(GPR) Applications',
        'place':'JNTU, Hyderbad',
        'from':'28.12.2017',
        'to':'30.12.2017'
    },
    {
        'sno':'8',
        'fac_name':'Dr.U.Natarajan,\nAssistant Professor/Mechanical',
        'prog_name':'Orientation Workshop for Start-Up Cell Coordinator',
        'place':'BIT,Mesra, Ranchi',
        'from':'16.01.2018',
        'to':'17.01.2018'
    },
    {
        'sno':'9',
        'fac_name':'Dr.M.Balasubramoniyan,\nAssociate Professor/EEE',
        'prog_name':'Electromagnetic and Antennas Design(WEAD-18)',
        'place':'IIT,(Bhu) Varanasi',
        'from':'23.05.2018',
        'to':'27.05.2018'
    },
    {
        'sno':'10',
        'fac_name':'Dr.S.Marirajmohan,\nAssistant Professor/Civil',
        'prog_name':'Application of total station and DGPS for Projects with Field Practices',
        'place':'ESCI, Hyderabad',
        'from':'23.07.2018',
        'to':'27.07.2018'
    },
    {
        'sno':'11',
        'fac_name':'Prof.C.Vennila,\nAssistant Professor/EEE',
        'prog_name':'Two Days Workshop on “Real Time Simulations of Electrical Systems”',
        'place':'JNTUH College of Engineering, Hyderabad',
        'from':'17.08.2018',
        'to':'	18.08.2018'
    },
    {
        'sno':'12',
        'fac_name':'Dr.A.Elango,\nPrincipal',
        'prog_name':'Intellectual property Rights',
        'place':'Andaman',
        'from':'26.09.2018',
        'to':'	27.09.2018'
    },
    {
        'sno':'13',
        'fac_name':'Dr.K.Baskaran,\nProfessor/EEE',
        'prog_name':'Professional Development Training',
        'place':'IIM, Shillong',
        'from':'26.09.2018',
        'to':'28.09.2018'
    },
    {
        'sno':'14',
        'fac_name':'Dr.S.M. Sivagami,\nAssistant Professor/Mechanical',
        'prog_name':'Advances in welding and materials processing',
        'place':'NIT, Calicut',
        'from':'29.12.2018',
        'to':'30.12.2018'
    },
    {
        'sno':'15',
        'fac_name':'Prof.G.Panneerselvam,\nAssociate Professor/Civil',
        'prog_name':'Principles and Application of GIS',
        'place':'Indian Institute of Technology (BHU) Varanasi',
        'from':'07.01.2019',
        'to':'12.01.2019'
    },
    {
        'sno':'16',
        'fac_name':'Prof.S.Venkatarajan,\nAssistant Professor/Physics',
        'prog_name':'International Conference on Materials Manufacturing and Machining',
        'place':'Bannari  Amman Institute of Technology, Sathyamangalam',
        'from':'08.03.2019',
        'to':'09.03.2019'
    },
    {
        'sno':'17',
        'fac_name':'Dr.B.Guruprasad,\nAssistant Professor/Mechanical',
        'prog_name':'Second International Conference on Sustainable Energy Resources, Materials and Technologies',
        'place':'SSN  College of Engineering, Chennai',
        'from':'14.03.2019',
        'to':'15.03.2019'
    },
    {
        'sno':'18',
        'fac_name':'Prof.G.Dhevanandhni,\nAssistant Professor/Civil',
        'prog_name':'International Conference on Advanced Concepts on Computational Engineering and Science (ICACCES-19)',
        'place':'Bharathiyar College of Engineering and Technology, Karaikal',
        'from':'15.03.2019',
        'to':'-'
    },
    {
        'sno':'19',
        'fac_name':'Dr.K.Baskaran,\nProfessor/EEE',
        'prog_name':'The Indian Smart Grid Forum Organizing “India Smart Utility Week (ISUW)2019',
        'place':'Manekshaw  Centre, New Delhi',
        'from':'13.03.2019',
        'to':'16.03.2019'
    },
    {
        'sno':'20',
        'fac_name':'Dr.B.V.Bhuvaneswari,\nProfessor/Physics',
        'prog_name':'National Conference on Advanced materials for Sustainable Energy and sensors',
        'place':'Alagappa University, Karaikudi',
        'from':'20.03.2019',
        'to':'23.03.2019'
    },
    {
        'sno':'21',
        'fac_name':'Dr.U.Natarajan,\nAssociate Professor/Mechanical',
        'prog_name':'Mechatronics, MEMS and Micro Fabrication',
        'place':'IIT, Indore',
        'from':'27.03.2019',
        'to':'29.03.2019'
    },
    {
        'sno':'22',
        'fac_name':'Prof.C.Karthika Pragadeeswari,\nAssistant Professor/ECE',
        'prog_name':'International conference on communication and Signal Processing',
        'place':'Adhiparasakthi Engineering college, Melmaruvathur',
        'from':'05.04.2019',
        'to':'-'
    },
    {
        'sno':'23',
        'fac_name':'Dr.N.Babu,\nAssistant Professor/Mechanical',
        'prog_name':'International  Conference on Material and Characterization',
        'place':'Adhi College of Engineering, Kanchipuram',
        'from':'08.05.2019',
        'to':'10.05.2019'
    },
    {
        'sno':'24',
        'fac_name':'Prof.G.Dhevanandhni,\nAssistant Professor/Civil',
        'prog_name':'Advances in Science and Humanities Technology',
        'place':'Savetha School of Engineering, Chennai',
        'from':'12.07.2019',
        'to':'-'
    },
    {
        'sno':'25',
        'fac_name':'Prof.L.Rasikannan,\nAssistant Professor/CSE',
        'prog_name':'Innovative Data Communication Technologies and application',
        'place':'RVS College of Engineeing and Technology, Coimbatore',
        'from':'17.10.2019',
        'to':'-'
    },
    {
        'sno':'26',
        'fac_name':'Prof.S.Selvaraj,\nAssistant Professor/Mechanical',
        'prog_name':'Multi scale modeling of sheet metal forming',
        'place':'IIT, Warangal',
        'from':'03.12.2019',
        'to':'07.12.2019'
    },
    {
        'sno':'27',
        'fac_name':'Prof.D.Helenamargaret,\nAssistant Professor/ECE',
        'prog_name':'Workshop on IOT and Artificial Intelligence',
        'place':'CIT, Coimbatore',
        'from':'05.12.2019',
        'to':'06.12.2019'
    },
    {
        'sno':'28',
        'fac_name':'Prof.K.Ramadas,\nAssociate Professor/EEE',
        'prog_name':'Workshop on Examination Reforms',
        'place':'KLE, Technological  University, Karnataka',
        'from':'20.01.2020',
        'to':'23.01.2020'
    }
]

const t3_acad1=[
    {   'sno':'1',
        'name':'Mr.M.Muthuramalingam',
        'desi':'Superintendent'
    },
    {   'sno':'2',
        'name':'Mr.M.Sivabalasubramaniyan',
        'desi':'Steno'
    },
    {   'sno':'3',
        'name':'Mr.N.Sethuraman',
        'desi':'Assistant'
    },
    {   'sno':'4',
        'name':'Mr.M.Tamilarasan',
        'desi':'Junior Assistant'
    },
    {   'sno':'5',
        'name':'Mr.C.Selvaraj',
        'desi':'Lab Assistant'
    },
    {   'sno':'6',
        'name':'Mr.C.Muthuramalingam',
        'desi':'Lab Assistant'
    },
    {   'sno':'7',
        'name':'Mr.P.Nachiappan',
        'desi':'JDO'
    },
    {   'sno':'8',
        'name':'Mr.K.Manimaran',
        'desi':'Electrician'
    },
    {   'sno':'9',
        'name':'Mr.G.Peter Ramesh',
        'desi':'Mechanic'
    },
    {   'sno':'10',
        'name':'Mr.KR.Rajendran',
        'desi':'Foreman Instructor'
    },
    {   'sno':'11',
        'name':'Mr.S.Saravanan',
        'desi':'Artisan I'
    },
    {   'sno':'12',
        'name':'Mr.R.Venkatraman',
        'desi':'Foundry  maistry'
    },
    {   'sno':'13',
        'name':'Mr.S.Senthilkumar',
        'desi':'Foreman Fitter'
    },
    {   'sno':'14',
        'name':'Mr.R.Velpandi',
        'desi':'Artisan I'
    },
    {   'sno':'15',
        'name':'Mr.B.Chandrasekaran',
        'desi':'Electrician'
    },
    {   'sno':'16',
        'name':'Mr.R.Vanmigivasudev',
        'desi':'Artisan II'
    },
    {   'sno':'17',
        'name':'Mr.P.L.Vellaisamy',
        'desi':'Lab Assistant'
    },
    {   'sno':'18',
        'name':'Mr.K.Lakshminarayanan',
        'desi':'Lab Assistant'
    },
    {   'sno':'19',
        'name':'Mr.M.Mahamani',
        'desi':'Lab Assistant'
    },
    {   'sno':'20',
        'name':'Mr.V.Rangarajan',
        'desi':'Lab Assistant'
    }
]

const t3_acad2=[
    {
        'sno':'1',
        'name':'Mrs.S.Manohari',
        'desi':'PA to Principal'
    },
    {
        'sno':'2',
        'name':'Mrs.A.Badhurunnishal',
        'desi':'Superintendent'
    },
    {
        'sno':'3',
        'name':'Mrs.P.Poornapuskalai',
        'desi':' Assistant'
    },
    {
        'sno':'4',
        'name':'Mrs.B.Akila',
        'desi':'Junior Assistant'
    },
    {
        'sno':'5',
        'name':'Ms.S.Benazir Begam',
        'desi':'Junior Assistant'
    },
    {
        'sno':'6',
        'name':'Mrs.C.Murugeswari',
        'desi':'Junior Assistant'
    },
    {
        'sno':'7',
        'name':'Mrs.A.Jeba kani',
        'desi':'Junior Assistant'
    },
    {
        'sno':'8',
        'name':'Mrs.R.Santhi',
        'desi':'Lab Assistant'
    },
    {
        'sno':'9',
        'name':'Mrs.R.Hema',
        'desi':'Instrument Repairer'
    },
    {
        'sno':'10',
        'name':'Mr.Unnikrishnan',
        'desi':'Lab Assistant'
    },
    {
        'sno':'11',
        'name':'Mrs.K.Santhi',
        'desi':'Oil Engine Driver'
    },
    {
        'sno':'12',
        'name':'Mr.M.Sakthivel',
        'desi':'Electrician'
    },
    {
        'sno':'13',
        'name':'Mr.J.Akbar Ali',
        'desi':'Electrician'
    },
    {
        'sno':'14',
        'name':'Mrs.I.Ananthi',
        'desi':'Lab Assistant'
    },
    {
        'sno':'15',
        'name':'Ms.B.Suriya',
        'desi':'Instrument Repairer'
    },
    {
        'sno':'16',
        'name':'Mrs.N.Vasanthimeena',
        'desi':'Lab Assistant'
    },
    {
        'sno':'17',
        'name':'Ms.D.Tamilselvi',
        'desi':'Mechanic -II'
    },
    {
        'sno':'18',
        'name':'Mrs.S.Suriya',
        'desi':'Lab Assistant'
    },
    {
        'sno':'19',
        'name':'Mrs.T.Uthaya Selvi',
        'desi':'Boiler Attender'
    }
]

const t3_acad3=[
    {
        'sno':'1',
        'name':'Mr.B.Chandrasekaran',
        'desi':'Electrician'
    },
    {
        'sno':'2',
        'name':'Mrs.M.Sumathy',
        'desi':'Steno Typist'
    },
    {
        'sno':'3',
        'name':'Mrs.C.Murugeswari',
        'desi':'Junior Assistant'
    },
    {
        'sno':'4',
        'name':'Ms.B.Suriya',
        'desi':'Instrument Repairer'
    },
    {
        'sno':'5',
        'name':'Mrs.S.Suriya',
        'desi':'Lab Assistant'
    },
    {
        'sno':'6',
        'name':'Mr.C.Selvaraj',
        'desi':'Lab Assistant'
    }
]

const t3_off_nodal=[
    {   'sno':'1',
        'name':'Prof.K.RAMADAS',
        'desig':'ASSOCIATE  PROFESSOR/EEE',
        'teq':'PROCUREMENT NODAL OFFICER',
        'mob':'9487895013',
        'email':'proframadas@gmail.com'
    },
    {   'sno':'2',
        'name':'Prof.K.T.LOGANATHAN',
        'desig':'ASSISTANT  PROFESSOR/CHEMISTRY',
        'teq':'PROCUREMENT ADDITIONAL NODAL OFFICER',
        'mob':'9486965858',
        'email':'logchem80@gmail.com'
    },
    {   'sno':'3',
        'name':'Dr.K.RAMANATHAN',
        'desig':'PROFESSOR (CAS)/MECH',
        'teq':'FINANCE NODAL OFFICER',
        'mob':'9994607024',
        'email':'ramsananthi@gmail.com'
    },
    {   'sno':'4',
        'name':'Dr.U.NATARAJAN',
        'desig':'PROFESSOR(CAS)/MECH',
        'teq':'EAP (EQUITY ACTION PLAN)',
        'mob':'9842011994',
        'email':'nattu33@gmail.com'
    },
    {   'sno':'5',
        'name':'Dr.K.BASKARAN',
        'desig':'PROFESSOR/EEE',
        'teq':'ACADEMICS',
        'mob':'9443661901',
        'email':'drbaskaran@gct.ac.in'
    },
    {   'sno':'6',
        'name':'Dr.S.PONMUDI',
        'desig':'ASSISTANT PROFESSOR/PHYSICS',
        'teq':'MIS (MANAGEMENT INFORMATION SYSTEM)',
        'mob':'9443476287',
        'email':'ponmudicdm1975@gmail.com '
    }

]

const t3_off_cell=[
    {   'sno':'1',
        'name':'Dr.K.KATHIRESAN',
        'desig':'ASSOCIATE PROFESSOR(CAS)/ENGLISH',
        'teq':'TEQIP CO – CORDINATOR -1',
        'mob':'9994273542',
        'email':'kathiresanaccet@gmail.com'
    },
    {   'sno':'2',
        'name':'Tmt.SR.CYNTHIA',
        'desig':'ASSISTANT PROFESSOR/PHYSICS',
        'teq':'TEQIP CO – CORDINATOR -2',
        'mob':'9442935526',
        'email':'srcynthiasam@gmail.com'
    },
    {   'sno':'3',
        'name':'Dr.B.GURUPRASAD',
        'desig':'ASSISTANT PROFESSOR/MECH',
        'teq':'R&D/I.I.I',
        'mob':'9486834009',
        'email':'tellprasad@hotmail.com'
    },
    {   'sno':'4',
        'name':'DR.C.SIVANESAN',
        'desig':'PROFESSOR(CAS)/CIVIL',
        'teq':'CIVIL WORKS',
        'mob':'9842257968',
        'email':'csivanesanc@gmail.com'
    }
    
]

const t3_off_depco=[
    {   'sno':'1',
        'name':'Dr.K.AARTHI',
        'desig':'ASSISTANT PROFESSOR/CIVIL',
        'teq':'CIVIL DEPARTMENT CO-ORDINATOR',
        'mob':'9789715066',
        'email':'aarthi.karmegam@gmail.com'
    },
    {   'sno':'2',
        'name':'Dr.R.SARALA',
        'desig':'ASSISTANT PROFESSOR/MECHANICAL',
        'teq':'MECHANICAL DEPARTMENT CO-ORDINATOR',
        'mob':'9486847610',
        'email':'sarala.sutharson@gmail.com'
    },
    {   'sno':'3',
        'name':'Thiru.S.BALA MURUGAN',
        'desig':'ASSISTANT PROFESSOR/EEE',
        'teq':'EEE DEPARTMENT CO-ORDINATOR',
        'mob':'9944405826',
        'email':'sbalaaccet@gmail.com'
    },
    {   'sno':'4',
        'name':'Tmt.D.HELENA MARGARET',
        'desig':'ASSISTANT PROFESSOR/ECE',
        'teq':'ECE DEPARTMENT CO-ORDINATOR',
        'mob':'9894220882',
        'email':'helenaraj@yahoo.com'
    },
    {   'sno':'5',
        'name':'Thiru.L.RASIKANNAN',
        'desig':'ASSISTANT PROFESSOR/CSE',
        'teq':'CSE DEPARTMENT CO-ORDINATOR',
        'mob':'9790424212',
        'email':'laxmanrasivalli@yahoo.co.in'
    },
    {   'sno':'6',
        'name':'Thiru.M.PERUMALSAMY',
        'desig':'ASSISTANT PROFESSOR/MATHS',
        'teq':'SCIENCE & HUMANITIES DEPARTMENT CO-ORDINATOR',
        'mob':'9443565006',
        'email':'pervas2014@gmail.com'
    }
]

const adstaff=[
    {   'sno':'1',
        'name':'Tmt.K.MANOHARI',
        'desig':'PA TO PRINCIPAL',
        'teq':'-',
        'mob':'9443978059',
        'email':'manohari.aravindhakshan@gmail.com'
    },
    {   'sno':'2',
        'name':'Tmt.J.THAVAMANI',
        'desig':'BURSAR',
        'teq':'-',
        'mob':'8300259442',
        'email':'jdhavamaniwpt@gmail.com'
    },
    {   'sno':'3',
        'name':'Thiru.AL.PRABAHAR',
        'desig':'SUPERINTENDENT ',
        'teq':'TEQIP SUPERINTENDENT ',
        'mob':'9443012999',
        'email':'alprabahar@gmail.com'
    },
    {   'sno':'4',
        'name':'Thiru.M.SIVABALASUBRAMANIAN',
        'desig':'STENO TYPIST',
        'teq':'TEQIP ASSISTANT',
        'mob':'9994174159',
        'email':'murugesansivabalan@gmail.com'
    }
]

const t3_procure=[
    {
        'sno':'1',
        'dept':'Civil ',
        'pack_name':'Pile Testing System with Frame',
        'amount':'7,29,750/-'
    },
    {
        'sno':'2',
        'dept':'Civil ',
        'pack_name':'PC Based Ultra Sonic Pulse Velocity Tester',
        'amount':'3,93,750/-'
    },
    {
        'sno':'3',
        'dept':'Civil ',
        'pack_name':'FTIR Spectrometer',
        'amount':'15,25,650/-'
    },
    {
        'sno':'4',
        'dept':'Mechanical',
        'pack_name':'Bottom Pouring Stir Casting Furnace with attachment',
        'amount':'11,76,000/-'
    },
    {
        'sno':'5',
        'dept':'Mechanical',
        'pack_name':'Energy Engineering Gadgets	',
        'amount':'8,21,425.50/-'
    },
    {
        'sno':'6',
        'dept':'Mechanical',
        'pack_name':'Vibration Comprehensive Experimental Teaching System',
        'amount':'8,40,000/-'
    },
    {
        'sno':'7',
        'dept':'Mechanical',
        'pack_name':'High Resolution Microscope (Optical)',
        'amount':'4,41,000/-'
    },
    {
        'sno':'8',
        'dept':'EEE',
        'pack_name':'Steel Chair 70Nos',
        'amount':'5,64,864/-'
    },
    {
        'sno':'9',
        'dept':'EEE',
        'pack_name':'Stools 150 Nos',
        'amount':'2,47,488/-'
    },
    {
        'sno':'10',
        'dept':'EEE',
        'pack_name':'Micro lab Box',
        'amount':'15,80,250/-'
    },
    {
        'sno':'11',
        'dept':'EEE',
        'pack_name':'i7 Computers',
        'amount':'34,40,880/-'
    },
    {
        'sno':'12',
        'dept':'EEE',
        'pack_name':'Smart Grid setup',
        'amount':'33,94,650/-'
    },
    {
        'sno':'13',
        'dept':'EEE',
        'pack_name':'30 KW Grid Interactive Solar Power Plant',
        'amount':'14,07,000/-'
    },
    {
        'sno':'14',
        'dept':'EEE',
        'pack_name':'GPU Based Nano Development Kit',
        'amount':'5,20,893.45/-'
    },
    {
        'sno':'15',
        'dept':'ECE',
        'pack_name':'CST Microwave Studio Software',
        'amount':'4,04,250/-'
    },
    {
        'sno':'16',
        'dept':'ECE',
        'pack_name':'Optiwave – Optisystem',
        'amount':'6,82,500/-'
    },
    {
        'sno':'17',
        'dept':'ECE',
        'pack_name':'Vector Network Analyzer',
        'amount':'27,43,597.50/-'
    },
    {
        'sno':'18',
        'dept':'ECE',
        'pack_name':'Spectrum Analyzer',
        'amount':'15,87,873/-'
    },
    {
        'sno':'19',
        'dept':'CSE',
        'pack_name':'15,87,873/-',
        'amount':'17,22,000/-'
    },
    {
        'sno':'20',
        'dept':'CSE',
        'pack_name':'Manageable Edge Switches and Power over Ethernet (PoE) Switches to Wi-Fi APs',
        'amount':'14,58,765/-'
    },
    {
        'sno':'21',
        'dept':'CSE',
        'pack_name':'Upgradation of Central Core Switch of Campus Wide Network',
        'amount':'22,05,000/-'
    },
    {
        'sno':'22',
        'dept':'Chemistry',
        'pack_name':'Electro Chemical Workstation',
        'amount':'29,85,724/-'
    },
    {
        'sno':'23',
        'dept':'Library',
        'pack_name':'E-Journals',
        'amount':'5,09,010/-'
    },
    {
        'sno':'24',
        'dept':'Library',
        'pack_name':'E-Books',
        'amount':'6,04,170/-'
    },
    {
        'sno':'25',
        'dept':'Library',
        'pack_name':' ASME Digital Collection',
        'amount':'2,25,292/-'
    },
    {
        'sno':'26',
        'dept':'Library',
        'pack_name':'ASCE Library',
        'amount':'2,70,723/-'
    },
    {
        'sno':'27',
        'dept':'TEQIP Office',
        'pack_name':'Copier Cum printer',
        'amount':'1,27,000/-'
    },
    {
        'pack_name':'Total amount',
        'amount':'3,26,09,505.45/-'
    }
]

const t3_twin=[
    {
        'sno':'1',
        'name':'Workshop on Outcome Based Education',
        'res':`Prof.G.Amuthan,\nProf.A.Dharanidharan`,
        'date':'09.03.2108 to 10.03.2018',
        'place':'UCET, Hazaribagh',
        'bene':'Faculty'
    },
    {
        'sno':'2',
        'name':'Workshop on Power Electronics and Drives',
        'res':'Dr.S.Nageswari',
        'date':'09.04.2018 to 14.04.2018',
        'place':'UCET, Hazaribagh',
        'bene':'III year Electrical Students'
    },
    {
        'sno':'3',
        'name':'Special Lecture on Introduction to Data Science',
        'res':'Prof.L.Rasikannan',
        'date':'07.03.2019',
        'place':'UCET, Hazaribagh',
        'bene':'III Year CSE Students'
    },
    {
        'sno':'4',
        'name':'Special Lecture on Soft Skills',
        'res':'Prof.K.Kathiresan',
        'date':'07.03.2019',
        'place':'UCET, Hazaribagh',
        'bene':'III Year Students'
    },
    {
        'sno':'5',
        'name':'Internet of Things and IoT Lab infrastructure Development',
        'res':'Dr.K.Baskaran,\nProf.V.Pradeep',
        'date':'12.03.2019',
        'place':'UCET, Hazaribagh',
        'bene':'Faculty'
    },
    {
        'sno':'6',
        'name':'Special Lecture on Electromagnetic Field',
        'res':'Prof.C.Mahendran',
        'date':'26.08.2019 to 28.08.2019',
        'place':'UCET, Hazaribagh',
        'bene':'III Year ECE Students'
    },
    {
        'sno':'7',
        'name':'Special Lecture on Hydraulics  and Pneumatics',
        'res':'Prof.S.Senthil kumar',
        'date':'26.08.2019 to 28.08.2019',
        'place':'UCET, Hazaribagh',
        'bene':'IV  Year  Mechanical Students'
    },
    {
        'sno':'8',
        'name':'Hands  on Training in JAVA Programming',
        'res':'Prof.K.Sundara krishnan',
        'date':'26.08.2019 to 28.08.2019',
        'place':'UCET, Hazaribagh',
        'bene':'II Year  CSE & IT  Students'
    },
    {
        'sno':'9',
        'name':'Workshop on “Outcome Based Education and Self Assessment Report (SAR) preparation for NBA Accreditation”',
        'res':'Prof.P.Perumal',
        'date':'01.07.2019',
        'place':'ACGCET - Karaikudi',
        'bene':'Faculty'
    },
    {
        'sno':'10',
        'name':'Institute governance practices and Academics Reforms',
        'res':'Dr.R.Shanmugalakshmi',
        'date':'01.07.2019',
        'place':'ACGCET - Karaikudi',
        'bene':'Faculty'
    }
]
export {teqip3,t3_acad,t3_acad1,t3_acad2,t3_acad3,t3_off_nodal,t3_off_cell,t3_off_depco,adstaff,t3_procure,t3_twin}